/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios"

import queryString from "query-string"

// const API_VERSION = "v1"
const onRequest = (config: InternalAxiosRequestConfig) => {
  config.headers.Api_Key = process.env.REACT_APP_API_KEY
  config.paramsSerializer = params =>
    queryString.stringify(params, { arrayFormat: "index" })
  return config
}

const onRequestError = (error: AxiosError) => {
  return Promise.reject(error)
}

const onResponse = (response: AxiosResponse) => {
  return response.data
}

const onResponseError = (responseError: AxiosError) => {
  return Promise.reject(responseError)
}

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
})

axiosInstance.interceptors.request.use(onRequest, onRequestError)
axiosInstance.interceptors.response.use(onResponse, onResponseError)

export default axiosInstance
